import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavBarComponent } from './core/nav-bar/nav-bar.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { RegisterComponent } from './modules/register/register.component';
import { MatNativeDateModule } from '@angular/material/core';
// import { MatSelectModule } from '@angular/material/select';
// import { MatButtonModule } from '@angular/material/button';
// import { MatDividerModule } from '@angular/material/divider';
// import { MatTableModule } from '@angular/material/table';
// import { MatIconModule } from '@angular/material/icon';
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { MatSnackBarModule } from '@angular/material/snack-bar';
// import { MatTabsModule } from '@angular/material/tabs';
// import { MatCheckboxModule } from '@angular/material/checkbox';
// import { MatRadioModule } from '@angular/material/radio';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AuthGuard } from './core/guard/auth.guard';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_DATE_FORMATS } from '../app/shared/pipes/date';
// import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { MatChipsModule } from '@angular/material/chips';

import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OverlayModule } from '@angular/cdk/overlay';
import { CdkTreeModule } from '@angular/cdk/tree';
import { PortalModule } from '@angular/cdk/portal';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BarcodeScannerLivestreamModule } from 'ngx-barcode-scanner';

import { TemplateComponent } from './shared/components/template/template.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LandingPagelayoutComponent } from './layouts/landing-pagelayout/landing-pagelayout.component';
import { HomeComponent } from './modules/home/home.component';
import { LoginTemplateComponent } from './shared/components/login-template/login-template.component';
import { LoginComponent } from './modules/login/login.component';
import { SignUpComponent } from './modules/sign-up/sign-up.component';
import { AuthServiceService } from './core/http/auth-service.service';
import { ObsService } from './core/http/obs.service';
import { SelfServiceService } from './core/http/self-service.service';
import { SettingsService } from './core/http/settings.service';
import { TitleModalComponent } from './shared/components/title-modal/title-modal.component';
import { ModalComponent } from './shared/components/modal/modal.component';
import { ModalService } from './shared/services/modal.service';
import { VoucherModalComponent } from './shared/components/voucher-modal/voucher-modal.component';
import { CountryModalComponent } from './shared/components/country-modal/country-modal.component';
import { StateModalComponent } from './shared/components/state-modal/state-modal.component';
import { CityModalComponent } from './shared/components/city-modal/city-modal.component';
import { CompanyModalComponent } from './shared/components/company-modal/company-modal.component';
import { BranchModalComponent } from './shared/components/branch-modal/branch-modal.component';
import { DepartmemtModalComponent } from './shared/components/departmemt-modal/departmemt-modal.component';
import { SubDepartmentModalComponent } from './shared/components/sub-department-modal/sub-department-modal.component';
import { BanksModalComponent } from './shared/components/banks-modal/banks-modal.component';
import { CardModalComponent } from './shared/components/card-modal/card-modal.component';
import { EmployeeModalComponent } from './shared/components/employee-modal/employee-modal.component';
import { CartegoryModalComponent } from './shared/components/cartegory-modal/cartegory-modal.component';
import { GroupsModalComponent } from './shared/components/groups-modal/groups-modal.component';
import { ItemsModalComponent } from './shared/components/items-modal/items-modal.component';
import { UomModalComponent } from './shared/components/uom-modal/uom-modal.component';
import { SpecializationModalComponent } from './shared/components/specialization-modal/specialization-modal.component';
import { SocModalComponent } from './shared/components/soc-modal/soc-modal.component';
import { AlocatedSocModalComponent } from './shared/components/alocated-soc-modal/alocated-soc-modal.component';
import { OpdModalComponent } from './shared/components/opd-modal/opd-modal.component';
import { OpdDetailModalComponent } from './shared/components/opd-detail-modal/opd-detail-modal.component';
import { RefDoctorModalComponent } from './shared/components/ref-doctor-modal/ref-doctor-modal.component';
import { BillNoModalComponent } from './shared/components/bill-no-modal/bill-no-modal.component';
import { NationalModalComponent } from './shared/components/national-modal/national-modal.component';
import { SnackbarComponent } from './shared/components/snackbar/snackbar.component';
import { SalesCardModalComponent } from './shared/components/sales-card-modal/sales-card-modal.component';
import { SetupModalComponent } from './shared/components/setup-modal/setup-modal.component';
import { SearchPipe } from './shared/pipes/search.pipe';
import { BillingComponent } from './modules/billing/billing.component';
import { EmailComponent } from './modules/communication/email/email.component';
import { SmsComponent } from './modules/communication/sms/sms.component';
import { ResultComponent } from './modules/communication/result/result.component';
import { ReceiptComponent } from './modules/communication/receipt/receipt.component';
import { FileComponent } from './modules/communication/file/file.component';
import { LogComponent } from './modules/communication/log/log.component';
import { CashierComponent } from './modules/cashier/cashier.component';
import { LedgerComponent } from './modules/ledger/ledger.component';
import { SampleCollectionComponent } from './modules/sample-collection/sample-collection.component';
import { SampleAcknolegeComponent } from './modules/sample-acknolege/sample-acknolege.component';
import { LabResultComponent } from './modules/lab-result/lab-result.component';
import { ResultFinaliseComponent } from './modules/result-finalise/result-finalise.component';
import { ResultPrintingComponent } from './modules/result-printing/result-printing.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { UserComponent } from './shared/components/user/user.component';
import { ReportComponent } from './modules/report/report.component';
import { CreateReportTemplateComponent } from './modules/create-report-template/create-report-template.component';
import { CreateParamComponent } from './modules/create-param/create-param.component';
import { ReportService } from './core/http/report.service';
import { SampleCollectModalComponent } from './shared/components/sample-collect-modal/sample-collect-modal.component';
import { SampleAcknoledgeModalComponent } from './shared/components/sample-acknoledge-modal/sample-acknoledge-modal.component';
import { ResultDispatchComponent } from './modules/result-dispatch/result-dispatch.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';
import { SignaturePadModule } from '@ng-plus/signature-pad';
import { PrintReceiptComponent } from './modules/print-receipt/print-receipt.component';
import { ObsComponent } from './modules/obs/obs.component';
import { FirstTrimesterComponent } from './shared/components/first-trimester/first-trimester.component';
import { SecondTrimesterComponent } from './shared/components/second-trimester/second-trimester.component';
import { ThirdTrimesterComponent } from './shared/components/third-trimester/third-trimester.component';
import { FtSingleComponent } from './shared/components/ft-single/ft-single.component';
import { FtTwinsComponent } from './shared/components/ft-twins/ft-twins.component';
import { FtTripletComponent } from './shared/components/ft-triplet/ft-triplet.component';
import { DropDownComponent } from './shared/components/drop-down/drop-down.component';
import { ObsResultComponent } from './modules/obs-result/obs-result.component';
import { ObsFTSResultComponent } from './modules/obs-fts-result/obs-fts-result.component';
import { ObsSTResultComponent } from './modules/obs-st-result/obs-st-result.component';
import { ObsTTResultComponent } from './modules/obs-tt-result/obs-tt-result.component';
import { ObsFTTwinResultComponent } from './modules/obs-fttwin-result/obs-fttwin-result.component';
import { ObsFTTripletsResultComponent } from './modules/obs-fttriplets-result/obs-fttriplets-result.component';
import { ObsFinalizeComponent } from './modules/obs-finalize/obs-finalize.component';
import { ScanComponent } from './modules/scan/scan.component';
import { InvoiceComponent } from './modules/invoice/invoice.component';
import { EncountersComponent } from './modules/encounters/encounters.component';
import { RefundComponent } from './shared/components/refund/refund.component';
import { PatientComponent } from './modules/patient/patient.component';
import { PreviewComponent } from './shared/components/preview/preview.component';
import { TestComponent } from './shared/components/test/test.component';
import { XRayComponent } from './modules/x-ray/x-ray.component';
import { XRayPrintComponent } from './modules/x-ray-print/x-ray-print.component';
import { QuillModule } from 'ngx-quill';
import { SendReviewComponent } from './shared/components/send-review/send-review.component';
import { AppointmentComponent } from './shared/components/appointment/appointment.component';
import { CreateAppointmentComponent } from './shared/components/create-appointment/create-appointment.component';
import { OnlineFinalizeComponent } from './modules/online-finalize/online-finalize.component';
import { OnlineViewResultComponent } from './modules/online-view-result/online-view-result.component';
import { OfflineAppointmentComponent } from './shared/components/offline-appointment/offline-appointment.component';
import { CommonModule } from '@angular/common';
import { BarcodeComponent } from './shared/components/barcode/barcode.component';
import { SanitizePipe } from './shared/pipe/sanitize.pipe';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { APP_INITIALIZER } from '@angular/core';
import { AppConfigService } from './core/services/config.service';
import { ObsResultOnlineComponent } from './modules/obs-result-online/obs-result-online.component';
import { ExportComponent } from './modules/export/export.component';
import { ExportDrComponent } from './modules/export-dr/export-dr.component';
import { ExportUserComponent } from './modules/export-user/export-user.component';
import { ExportEmployeeComponent } from './modules/export-employee/export-employee.component';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { ChangePasswordComponent } from './modules/change-password/change-password.component';
import { RadioComponent } from './modules/radio/radio.component';
import { RadioPrintComponent } from './modules/radio-print/radio-print.component';
import { SidenavComponent } from './shared/components/sidenav/sidenav.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RadioOthersComponent } from './modules/radio-others/radio-others.component';
import { FinalizeModalComponent } from './shared/components/finalize-modal/finalize-modal.component';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WaitingListComponent } from './modules/waiting-list/waiting-list.component';
import { RefundAmountComponent } from './modules/refund-amount/refund-amount.component';
import { RefundReceiptModalComponent } from './shared/components/refund-receipt-modal/refund-receipt-modal.component';
import { RadiologyWaitingListComponent } from './modules/radiology-waiting-list/radiology-waiting-list.component';
import { PatientBillsComponent } from './modules/patient-bills/patient-bills.component';
import { GraphChartComponent } from './modules/graph-chart/graph-chart.component';
import { AddQcModalComponent } from './shared/components/add-qc-modal/add-qc-modal.component';
import { PaginationComponent } from './shared/components/pagination/pagination.component';

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    MainLayoutComponent,
    DashboardLayoutComponent,
    RegisterComponent,
    TemplateComponent,
    LandingPagelayoutComponent,
    HomeComponent,
    LoginTemplateComponent,
    LoginComponent,
    SignUpComponent,
    TitleModalComponent,
    ModalComponent,
    VoucherModalComponent,
    CountryModalComponent,
    StateModalComponent,
    CityModalComponent,
    CompanyModalComponent,
    BranchModalComponent,
    DepartmemtModalComponent,
    SubDepartmentModalComponent,
    BanksModalComponent,
    CardModalComponent,
    EmployeeModalComponent,
    CartegoryModalComponent,
    GroupsModalComponent,
    ItemsModalComponent,
    UomModalComponent,
    SpecializationModalComponent,
    SocModalComponent,
    AlocatedSocModalComponent,
    OpdModalComponent,
    OpdDetailModalComponent,
    RefDoctorModalComponent,
    BillNoModalComponent,
    NationalModalComponent,
    SnackbarComponent,
    SalesCardModalComponent,
    SetupModalComponent,
    SearchPipe,
    BillingComponent,
    EmailComponent,
    SmsComponent,
    ResultComponent,
    ReceiptComponent,
    FileComponent,
    LogComponent,
    CashierComponent,
    LedgerComponent,
    SampleCollectionComponent,
    SampleAcknolegeComponent,
    LabResultComponent,
    ResultFinaliseComponent,
    ResultPrintingComponent,
    ProfileComponent,
    UserComponent,
    ReportComponent,
    CreateReportTemplateComponent,
    CreateParamComponent,
    SampleCollectModalComponent,
    SampleAcknoledgeModalComponent,
    ResultDispatchComponent,
    NotFoundComponent,
    PrintReceiptComponent,
    ObsComponent,
    FirstTrimesterComponent,
    SecondTrimesterComponent,
    ThirdTrimesterComponent,
    FtSingleComponent,
    FtTwinsComponent,
    FtTripletComponent,
    DropDownComponent,
    ObsResultComponent,
    ObsFTSResultComponent,
    ObsSTResultComponent,
    ObsTTResultComponent,
    ObsFTTwinResultComponent,
    ObsFTTripletsResultComponent,
    ObsFinalizeComponent,
    ScanComponent,
    InvoiceComponent,
    EncountersComponent,
    RefundComponent,
    PatientComponent,
    PreviewComponent,
    TestComponent,
    XRayComponent,
    XRayPrintComponent,
    SendReviewComponent,
    AppointmentComponent,
    CreateAppointmentComponent,
    OnlineFinalizeComponent,
    OnlineViewResultComponent,
    OfflineAppointmentComponent,
    BarcodeComponent,
    SanitizePipe,
    ObsResultOnlineComponent,
    ExportComponent,
    ExportDrComponent,
    ExportUserComponent,
    ExportEmployeeComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    RadioComponent,
    RadioPrintComponent,
    SidenavComponent,
    HeaderComponent,
    SidebarComponent,
    RadioOthersComponent,
    FinalizeModalComponent,
    WaitingListComponent,
    RefundAmountComponent,
    RefundReceiptModalComponent,
    RadiologyWaitingListComponent,
    PatientBillsComponent,
    GraphChartComponent,
    AddQcModalComponent,
    PaginationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    MatMenuModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatListModule,
    MatSelectModule,
    MatDividerModule,
    MatStepperModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatTreeModule,
    MatToolbarModule,
    PortalModule,
    MatGridListModule,
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    OverlayModule,
    MatCardModule,
    MatBottomSheetModule,
    MatNativeDateModule,
    MatBadgeModule,
    CdkTreeModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatRadioModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    SignaturePadModule,
    QuillModule.forRoot(),
    MatAutocompleteModule,
    MatChipsModule,
    CommonModule,
    BarcodeScannerLivestreamModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    FlexLayoutModule,
    MatDialogModule,
  ],
  providers: [
    AuthServiceService,
    ModalService,
    SettingsService,
    ReportService,
    ObsService,
    SelfServiceService,
    AuthGuard,
    AppConfigService,
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => () =>
        appConfigService.loadAppConfig(),
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    // BarcodeScannerLivestreamModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
